export default {
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL || "http://10342ts38rd99.vicp.fun"
}
// export default {
//   API_BASE_URL: process.env.VUE_APP_API_BASE_URL || "http://192.168.2.124:8000"
// }